<template>
  <v-container class="subheading">
    <v-layout text-xs-center wrap>
      <v-spacer></v-spacer>
      <v-flex md8 text-xs-left>
        <v-card flat light>
          <v-card-title primary-title>
            <v-flex text-xs-left>
              <div class="headline mb-0">Research Interests</div>
              <br>My primary area of research is Distributed Systems. I enjoy both theoretical and system aspect of this subject.
              In particular, I have been primarily looking at programming abstractions for distributed systems. 
            </v-flex>
          </v-card-title>
        </v-card>
        <v-card flat light>
          <v-card-title primary-title>
            <v-flex text-xs-left>
              <div class="headline mb-0">Distributed Graph Processing</div>
              <br>I previously worked on distributed graph processing at
              <a href="http://dream-lab.cds.iisc.ac.in/" target="_blank">DREAM Lab</a>, under the guidance of Prof 
              <a href="http://cds.iisc.ac.in/faculty/simmhan/" target="_blank">Yogesh Simmhan</a>.
              We developed framework (GoFFish) for processing large scale graphs.
              I also worked on designing distributed graph algorithms for GoFFish and presented my work at
              <a
                href="https://www.hipc.org/hipc2016/studentsymposium.php"
                target="_blank"
              >HiPC 2016 Student Research Symposium</a>, where it received the joint-best poster award.
              <br>
              <br>The paper is available on
              <a href="https://arxiv.org/abs/1905.08051" target="_blank">ArXiv</a> and source code on
              <a href="https://github.com/dream-lab/goffish_v3/" target="_blank">GitHub</a>.
            </v-flex>
          </v-card-title>
        </v-card>

        <v-card flat light>
          <v-card-title primary-title>
            <v-flex text-xs-left>
              <div class="headline mb-0">Causal Consistency Protocol</div>
              <br>My recent work on a novel protocol for causally consistent Read Only Transactions (ROT) got accepted at <a href="https://papoc-workshop.github.io/2020/">PaPoC 2020</a>.
              <br>
              <br>The paper is available
              <a href="/Orion_PaPoC.pdf" target="_blank">here</a> and source code on
              <a href="https://github.com/dipkakwani/Orion" target="_blank">GitHub</a>.
            </v-flex>
          </v-card-title>
        </v-card>

        <v-card flat light>
          <v-card-title primary-title>
            <v-flex text-xs-left>
              <div class="headline mb-0">Current Research</div>
              <br>My current direction of research focuses on designing programming abstractions for using various distributed consistencies.              
            </v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Research",
  data: function() {
    return {
      //
    };
  }
};
</script>
